export default {
    'online': {
        'login': 'Log In',
        'try_course': 'Try Course',
        'testimonials': 'Testimonials',
        'barbara_minto': 'Video',
        'buy_course': 'Buy <br> Course',
        'corporate_inquiry': 'Corporate Inquiry',
        'text': `<img src="/assets/images/coming-soon.png" alt="coming-soon" title="coming-soon" />
            <div class="content-caption-box">
                <h3 class="content-caption">The 2021 online course: Fully rewritten, with all new technology</h3>
            </div>
            <p class="content-text">The completely new Minto Online Course is a pinnacle in digital learning, reflecting 30 years of teaching and
                development. It is easily the world’s most complete computer teaching system for business writing and thinking.
            </p>`,
    }
}


// WEBPACK FOOTER //
// ./client/app/modules/site/onlineCourse/i18n/en.js